import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UcatLayout, UcatModal } from "../../Components/Shared";
import { Button } from "../../Components/Practice_Test/UI";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import { ReactComponent as InfoSvg } from "../../Assests/icons8-info (1).svg";
import {
  FileText,
  SquarePlus,
  SquareMinus,
  LogOut,
  Flag,
  PenLine,
  Info,
  CheckCircle,
  XCircle
} from "lucide-react";
import { listReViewExamIDPractice } from "../../../../Redux/Slices/ReViewExamPractice/ListReViewExamPracticeSlice";
import { listReViewExamID } from "../../../../Redux/Slices/ReViewExam/ListReViewExamSlice";
import { listEvaluation } from "../../../../Redux/Slices/Exam/ListEvaluationSlice";
import { listEvaluationPractice } from "../../../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import { addFalgExam } from "../../../../Redux/Slices/FalgExam/AddFalgExamSlice";
import { addFalg } from "../../../../Redux/Slices/Falg/AddFalgSlice";
import { listFlag, successlistFlag } from "../../../../Redux/Slices/Falg/ListFlagSlice";
import { listFlagExam } from "../../../../Redux/Slices/FalgExam/ListFlagExamSlice";
import { CircularProgress } from "@mui/material";
import { EndReviewConfirmationModal, NoFlaggedModal } from "../../Components/Practice_Test/Exam_component";
import useNavigationBlocker from '../../../../Hooks/useNavigationBlocker';


// TestResultScreen ?
export const UcatResultScreen = () => {

  const location = useLocation();
  const state = location.state as any;

  // Persist state to handle reloads
  useEffect(() => {
    if (state && typeof state === 'object') {
      sessionStorage.setItem("ucat_result_state", JSON.stringify(state));
    }
  }, [state]);

  const persistedStateStr = sessionStorage.getItem("ucat_result_state");
  const persistedState = persistedStateStr ? JSON.parse(persistedStateStr) : null;
  const activeState = (state && typeof state === 'object') ? state : persistedState;

  const evalAs = activeState?.evalAs;
  const studentExamId = activeState?.studentExamId || activeState?.id; // Allow both naming conventions
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showInstructions, setShowInstructions] = useState(false);
  const [isReviewState, setIsReviewState] = useState(true);
  const [showEndReviewConfirmation, setShowEndReviewConfirmation] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [isCheckingFlags, setIsCheckingFlags] = useState(false);
  const [showNoFlaggedModal, setShowNoFlaggedModal] = useState(false);

  useNavigationBlocker(!showEndReviewConfirmation && !isNavigating);

  // Get student_test_id from ListStudentExamSlice for practice tests
  const { data: listStudentExamSlice } = useAppSelector(
    (state) => state.ListStudentExamSlice
  );

  const { data: listReViewExamIDSlice, isLoading: Reviewdata } = useAppSelector(
    (state) => state.ListReViewExamIDSlice || {}
  );

  const { data: listReViewExamPracticeSlice, isLoading: ReviewdataPractice } = useAppSelector(
    (state: any) => state.ListReViewExamIDPracticeSlice || {}
  );

  const { data: listEvaluationSlice, isLoading: LoadingEval } = useAppSelector(
    (state) => state.ListEvaluationSlice || {}
  );

  const { data: listEvaluationPracticeSlice, isLoading: LoadingEvalPractice } = useAppSelector(
    (state) => state.ListEvaluationPracticeSlice || {}
  );

  const { data: listFlagSlice, isLoading: isFlagLoading } = useAppSelector(
    (state) => state.ListFlagSlice
  );

  const { data: listFlagExamSlice, isLoading: isFlagExamLoading } = useAppSelector(
    (state: any) => state.ListFlagExamSlice || {}
  );

  const { data: addFlagRes } = useAppSelector(
    (state) => state.AddFalgSlice
  );

  const { data: addFlagExamRes } = useAppSelector(
    (state) => state.AddFalgExamSlice
  );

  const [expandedSections, setExpandedSections] = useState<Set<number>>(new Set([0]));
  const [summaryExpanded, setSummaryExpanded] = useState(false);

  const localResults = activeState || {
    total: 0,
    correct: 0,
    sectionTitle: "Exam Result",
    questionsByType: [],
    studentExamId: null
  };

  // For practice tests, use id from ListStudentExamSlice
  const studentTestId = (listStudentExamSlice as any)?.data?.id || null;

  const idToUse = studentExamId || studentTestId;
  const evaluationTriggered = React.useRef(false);
  const [evalLoadHasStarted, setEvalLoadHasStarted] = useState(false);

  useEffect(() => {
    if (idToUse && !evaluationTriggered.current) {
      if (evalAs === "exam") {
        dispatch(listEvaluation({ student_exam_id: idToUse }));
      } else if (evalAs === "test") {
        dispatch(listEvaluationPractice({ student_test_id: idToUse }));
      }
      evaluationTriggered.current = true;
    }
  }, [dispatch, idToUse, evalAs]);

  useEffect(() => {
    if (LoadingEvalPractice === true || LoadingEval === true) {
      setEvalLoadHasStarted(true);
    }
  }, [LoadingEvalPractice, LoadingEval]);

  useEffect(() => {
    const hasEvalData = evalAs === "exam"
      ? listEvaluationSlice && (Array.isArray(listEvaluationSlice) ? listEvaluationSlice.length > 0 : !!listEvaluationSlice)
      : listEvaluationPracticeSlice && (Array.isArray(listEvaluationPracticeSlice) ? listEvaluationPracticeSlice.length > 0 : !!listEvaluationPracticeSlice);

    const isLoading = evalAs === "exam" ? LoadingEval : LoadingEvalPractice;
    const hasReviewData = evalAs === "exam" ? listReViewExamIDSlice : listReViewExamPracticeSlice;
    const isReviewLoading = evalAs === "exam" ? Reviewdata : ReviewdataPractice;

    if (idToUse && evaluationTriggered.current && isLoading === false && hasEvalData && !hasReviewData?.data && !isReviewLoading) {
      // console.log("✅ Evaluation successful/ready, now fetching review data for id:", idToUse, "evalAs:", evalAs);
      if (evalAs === "exam") {
        dispatch(listReViewExamID({ id: idToUse }));
      } else if (evalAs === "test") {
        dispatch(listReViewExamIDPractice({ id: idToUse }));
      }
    }
  }, [dispatch, idToUse, LoadingEval, LoadingEvalPractice, listEvaluationSlice, listEvaluationPracticeSlice, listReViewExamIDSlice, listReViewExamPracticeSlice, Reviewdata, ReviewdataPractice, evalLoadHasStarted, evalAs]);

  // Fetch flags on mount
  useEffect(() => {
    if (idToUse) {
      if (evalAs === "exam") {
        dispatch(listFlagExam({ student_exam_id: Number(idToUse) }));
      } else {
        dispatch(listFlag({ student_test_id: Number(idToUse) }));
      }
    }
  }, [dispatch, idToUse, evalAs]);

  // Re-fetch flags after toggling
  useEffect(() => {
    if (idToUse) {
      if (evalAs === "exam") {
        dispatch(listFlagExam({ student_exam_id: Number(idToUse) }));
      } else {
        dispatch(listFlag({ student_test_id: Number(idToUse) }));
      }
    }
  }, [dispatch, idToUse, addFlagRes, addFlagExamRes, evalAs]);

  const sectionTitle = listReViewExamIDSlice?.data?.exam_name || listReViewExamPracticeSlice?.data?.exam_name || "UCAT Exam";

  const handleEndReview = () => {
    setShowEndReviewConfirmation(true);
  };

  const handleEndReviewConfirm = () => {
    console.warn("Navigating to ucat_end_exam with state:", { endNavPath: "/practicetest" });
    navigate("/ucat_end_exam", {
      state: {
        endNavPath: evalAs === "exam" ? "/ucat_test" : "/practicetest",
        renderFor: evalAs,
        headerTitle: sectionTitle
      }
    });
  };

  const handleEndReviewCancel = () => {
    setShowEndReviewConfirmation(false);
  };

  const toggleSection = (index: number) => {
    const next = new Set(expandedSections);
    if (next.has(index)) {
      next.delete(index);
    } else {
      next.add(index);
    }
    setExpandedSections(next);
  };

  // Navigate to review exam page with the student exam ID
  const handleReviewQuestion = (questionId: number, questionIdxInFiltered?: number) => {
    const idToUse = localResults.studentExamId || studentTestId;
    if (idToUse) {
      setIsNavigating(true);
      navigate("/ucat_test_review", {
        state: {
          studentExamId: idToUse,
          filterType: "all",
          initialQuestionIndex: questionIdxInFiltered || 0,
          evalAs: evalAs
        }
      });
    }
  };

  const handleReviewAll = () => {
    const idToUse = localResults.studentExamId || studentTestId;
    if (idToUse) {
      setIsNavigating(true);
      navigate("/ucat_test_review", {
        state: {
          studentExamId: idToUse,
          filterType: "all",
          initialQuestionIndex: 0,
          evalAs: evalAs
        }
      });
    }
  };

  const handleReviewIncorrect = () => {
    const idToUse = localResults.studentExamId || studentTestId;
    if (idToUse) {
      setIsNavigating(true);
      navigate("/ucat_test_review", {
        state: {
          studentExamId: idToUse,
          filterType: "incomplete",
          initialQuestionIndex: 0,
          evalAs: evalAs
        }
      });
    }
  };

  const handleReviewFlagged = () => {
    const idToUse = localResults.studentExamId || studentTestId;
    if (idToUse) {
      setIsCheckingFlags(true);
      if (evalAs === "exam") {
        dispatch(listFlagExam({ student_exam_id: Number(idToUse) }));
      } else {
        dispatch(listFlag({ student_test_id: Number(idToUse) }));
      }
    }
  };

  useEffect(() => {
    if (isCheckingFlags) {
      const isLoading = evalAs === "exam" ? isFlagExamLoading : isFlagLoading;

      if (isLoading === false) {
        setIsCheckingFlags(false);
        const relevantSlice = evalAs === "exam" ? listFlagExamSlice : listFlagSlice;
        const responseObj = relevantSlice?.data as any;
        // Handle various response structures
        const flagItems = responseObj?.data || (Array.isArray(relevantSlice?.data) ? relevantSlice?.data : (Array.isArray(relevantSlice) ? relevantSlice : []));

        const hasFlagged = flagItems?.some((f: any) => f.flagged);

        if (hasFlagged) {
          const idToUse = localResults.studentExamId || studentTestId;
          setIsNavigating(true);
          navigate("/ucat_test_review", {
            state: {
              studentExamId: idToUse,
              filterType: "flagged",
              initialQuestionIndex: 0,
              evalAs: evalAs
            }
          });
        } else {
          setShowNoFlaggedModal(true);
        }
      }
    }
  }, [isCheckingFlags, isFlagLoading, isFlagExamLoading, listFlagSlice, listFlagExamSlice, evalAs, localResults.studentExamId, studentTestId, navigate]);

  const handleToggleFlag = (questionId: number, currentFlagState: boolean, e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row click

    const idToUse = localResults.studentExamId || studentTestId;
    if (idToUse) {
      // Debug logging to check the values
      console.log("Toggling flag - questionId:", questionId, "idToUse:", idToUse);

      // Check if questionId is valid
      if (!questionId || questionId === undefined || questionId === null) {
        console.error("Invalid questionId:", questionId);
        return;
      }

      // Dispatch flag API call - this API toggles the flag state
      if (evalAs == "exam") {
        dispatch(addFalgExam({
          student_exam_id: idToUse,
          question_id: questionId
        }))
      }
      else if (evalAs == "test") {
        const payload = {
          student_test_id: idToUse,
          question_id: questionId
        };
        // console.log("Payload being sent:", payload);
        dispatch(addFalg(payload))
      }

      // console.log("Flag toggled for question:", questionId, "current state:", currentFlagState);

      // Note: For immediate UI update, you might want to update local state
      // or refetch the evaluation data to see the updated flag state
    }
  };

  // Extract data from API response
  const reviewDataRaw = evalAs === "exam"
    ? listReViewExamIDSlice?.data || listReViewExamIDSlice
    : listReViewExamPracticeSlice?.data || listReViewExamPracticeSlice;
  const reviewData: any = reviewDataRaw;
  const allQuestions = reviewData?.questions || [];

  // Group questions by type
  const questionsByType: Record<string, any[]> = {};
  allQuestions.forEach((q: any) => {
    const typeName = q.Question_type_name || q.question_type_name || "General";
    if (!questionsByType[typeName]) {
      questionsByType[typeName] = [];
    }
    questionsByType[typeName].push(q);
  });

  const findQuestionsLine = (obj: any): any[] => {
    if (!obj) return [];
    if (Array.isArray(obj)) {
      if (obj[0]?.questions_line) return obj[0].questions_line;
      if (obj[0]?.question_time_taken) return obj[0].question_time_taken;
      if (obj.length > 0 && obj[0]?.question_id) return obj;
      return [];
    }
    if (obj.questions_line) return obj.questions_line;
    if (obj.question_time_taken) return obj.question_time_taken;
    if (obj.data?.questions_line) return obj.data.questions_line;
    if (obj.data?.question_time_taken) return obj.data.question_time_taken;
    if (obj.data) {
      if (Array.isArray(obj.data)) return obj.data[0]?.questions_line || obj.data[0]?.question_time_taken || [];
      if (obj.data.questions_line) return obj.data.questions_line;
      if (obj.data.question_time_taken) return obj.data.question_time_taken;
      return findQuestionsLine(obj.data);
    }
    return [];
  };

  const evaluationLines = evalAs === "exam" ? findQuestionsLine(listEvaluationSlice) : findQuestionsLine(listEvaluationPracticeSlice);

  const evaluationMap = new Map();
  evaluationLines.forEach((item: any) => {
    evaluationMap.set(Number(item.question_id), item);
  });

  // Create subsections
  const subsections = Object.entries(questionsByType).map(([typeName, questions], sectionIdx) => {
    const questionStatuses = questions.map((q: any) => {
      // Improved qId logic: try to find the actual DB ID first
      const qId = q.id || q.questionId || q.question_id;
      const evalItem = evaluationMap.get(Number(qId));

      // Use appropriate flag slice based on evalAs
      const relevantFlagSlice = evalAs === "exam" ? listFlagExamSlice : listFlagSlice;
      const responseObj = relevantFlagSlice?.data as any;
      const flagItems = responseObj?.data || (Array.isArray(relevantFlagSlice?.data) ? relevantFlagSlice?.data : null);
      const hasFlagsLoaded = Array.isArray(flagItems);

      // Question ID for matching - prioritize Database ID (id) then fallback to others
      // const qId = q.id || q.questionId || q.question_id;

      const serverFlag = hasFlagsLoaded ? flagItems.find((f: any) => {
        // STRICT MATCH: Match against question identifiers in the flag record
        const fQId = f.question_id || f.questionId;
        return fQId && Number(fQId) === Number(qId);
      }) : null;

      // STICK TO USER REQUEST: Only get flag data from flag get api, no fallback to review answer data.
      const isFlagged = !!serverFlag?.flagged;

      let status = "Unseen";
      let isCorrect = false;

      // Prioritize Evaluation API data
      if (evalItem) {
        const hasServerAnswer = (evalItem.option_id != null) ||
          (evalItem.answer_data && evalItem.answer_data !== "null" && evalItem.answer_data !== "{}") ||
          (evalItem.sentence && evalItem.sentence !== "null" && evalItem.sentence !== "{}") ||
          (evalItem.correct !== null && evalItem.correct !== "null" && evalItem.correct !== undefined);

        const isSkipped = evalItem.skipped === true || evalItem.skipped === "true" || evalItem.skipped === 1;
        const timeTakenVal = evalItem.time_taken || evalItem.time_taken_seconds;
        const isIncompleteTime = timeTakenVal && Number(timeTakenVal) > 0;

        if (hasServerAnswer) {
          isCorrect = evalItem.correct === true || evalItem.correct === "true" || evalItem.correct === 1 || evalItem.correct === "correct";
          status = isCorrect ? "Correct" : "Incorrect";
        } else if (isIncompleteTime) {
          status = "Incomplete";
        } else {
          status = "Unseen";
        }
      } else {
        // Fallback to review API data if evaluation data is missing
        const chosenOption = q.options?.find((opt: any) => opt.chosen);
        if (chosenOption) {
          isCorrect = !!chosenOption.is_correct;
          status = isCorrect ? "Correct" : "Incorrect";
        } else if (q.answer_items && Array.isArray(q.answer_items) && q.answer_items.some((item: any) => item.value)) {
          status = "Incorrect";
        }
      }

      return {
        ...q, // Preserve all original fields to avoid metadata loss
        question_id: qId, // Uniform ID field for display/review
        status: status,
        isFlagged: isFlagged,
        isCorrect: isCorrect
      };
    });

    const incorrectCount = questionStatuses.filter(qs => qs.status === "Incorrect" || qs.status === "Incomplete" || qs.status === "Unseen").length;

    return {
      name: typeName,
      count: questions.length,
      incorrect: incorrectCount,
      questions: questionStatuses
    };
  });

  const getStatusColor = (status: string) => {
    const s = status.toLowerCase();
    if (s === "correct") return "text-green-600";
    if (s === "incorrect" || s === "unseen" || s === "wrong" || s === "incomplete") return "text-[#E00]";
    return "text-gray-500";
  };

  const formatStatus = (status: string) => {
    if (!status) return "Unseen";
    const s = status.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.altKey) {
        const key = e.key.toLowerCase();
        e.preventDefault();

        switch (key) {
          case 'e':
            handleEndReview();
            break;
          case 'a':
            handleReviewAll();
            break;
          case 'i':
            handleReviewIncorrect();
            break;
          case 'v':
            handleReviewFlagged();
            break;
          case 'r':
            setShowInstructions(true);
            break;
          // case 'y':
          //   if (showEndReview && onEndReviewConfirm) {
          //     onEndReviewConfirm();
          //   }
          //   break;
          // case 'n':
          //   if (showEndReview && onEndReviewCancel) {
          //     onEndReviewCancel();
          //   }
          //   break;
        }
      }

      // Esc to close instruction modal
      if (e.key === 'Escape' && showInstructions) {
        setShowInstructions(false);
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleReviewAll, handleReviewIncorrect, handleReviewFlagged, handleEndReview, showInstructions]);


  const isLoading = Reviewdata || ReviewdataPractice || LoadingEval || LoadingEvalPractice;

  return (
    <>
      <UcatLayout
        headerTitle={sectionTitle}
        showToolbar={true}
        toolbarLeftActions={
          isReviewState && (
            <button
              onClick={() => setShowInstructions(true)}
              className="flex items-center gap-2 text-white hover:text-[#FFFF00] text-[14px] font-medium p-1 ml-2"
            >
              <PenLine size={16} />
              <span className="text-[18px] underline decoration-1 f-tahoma">
                Instructions
              </span>
            </button>
          )
        }
        footerProps={{
          onEndExam: handleEndReview,
          leftButtonText: "End Review",
          customRightActions: (
            <>
              <button
                onClick={handleReviewAll}
                disabled={isLoading}
                className={`bg-transparent text-white text-[19px] font-normal h-full px-4 border-l-[2px] border-white ${isLoading ? "cursor-default pointer-events-none opacity-60" : "hover:bg-white/10"} flex items-center gap-1 rounded-[2px]`}
              >
                <CheckCircle size={18} className="mr-0.5" />
                <span className="text-[19px]">Review <span className="underline decoration-1 underline-offset-2 text-[19px]">A</span>ll</span>
              </button>
              <button
                onClick={handleReviewIncorrect}
                disabled={isLoading}
                className={`bg-transparent text-white text-[19px] font-normal h-full px-4 border-l-[2px] border-white ${isLoading ? "cursor-default pointer-events-none opacity-60" : "hover:bg-white/10"} flex items-center gap-1 rounded-[2px]`}
              >
                <XCircle size={18} className="mr-0.5" />
                <span className="text-[19px]">Review <span className="underline decoration-1 underline-offset-2 text-[19px]">I</span>ncorrect</span>
              </button>
              <button
                onClick={handleReviewFlagged}
                disabled={isLoading}
                className={`bg-transparent text-white text-[19px] font-normal h-full px-4 border-l-[2px] border-white ${isLoading ? "cursor-default pointer-events-none opacity-60" : "hover:bg-white/10"} flex items-center gap-1 rounded-[2px]`}
              >
                <Flag size={18} className="fill-white mr-0.5" />{/** may need change */}
                <span className="text-[19px]">Re<span className="underline decoration-1 underline-offset-2 text-[19px]">v</span>iew Flagged</span>
              </button>
            </>
          )
        }}
      >
        <div className="flex flex-col h-full bg-white select-none overflow-hidden min-h-0 items-center bg-gray-50/50">
          <div className="p-1 flex items-center gap-2 text-[#000]-700 w-full bg-gray-50/50">
            <div className="flex-1 text-center text-[19px] font-[400] pr-10 mb-[10px] f-tahoma">
              {evalAs == "test" && `${reviewData?.exam_name || ""} Review `}
              Postscore: see which items are incorrect and return to them to see the solution
            </div>
          </div>

          <div className="flex-1 overflow-y-auto ucat-scrollbar min-h-0 w-full p-0 flex flex-col items-center">
            <div className="w-full p-4 space-y-4 max-w-full">
              {isLoading ? (
                <div className="flex flex-col items-center justify-center py-20 bg-white w-full">
                  <CircularProgress />
                  <p className="mt-3 text-[#005a9c] font-medium">Loading results...</p>
                </div>
              ) : (
                <>
                  {subsections.length > 0 ? (
                    subsections.map((sub: any, index: number) => {
                      const isExpanded = expandedSections.has(index);
                      return (
                        <div key={index} className="flex flex-col">
                          <div
                            onClick={() => toggleSection(index)}
                            className="flex items-center justify-between px-4 py-1 bg-[#507abd] text-white hover:bg-[#4068a0] transition-colors cursor-pointer rounded-sm"
                          >
                            <div className="flex items-center gap-3">
                              {isExpanded ? <SquareMinus size={18} className="text-white/90" /> : <SquarePlus size={18} strokeWidth={3} className="text-white/90" />}
                              <span className="text-[19px] font-medium f-tahoma">
                                Question Bank Section {index + 1} - {sub.name}
                              </span>
                            </div>
                            <div className="text-[19px] font-medium f-tahoma tracking-wide">
                              ( {sub.count} Questions , {sub.incorrect} Incorrect )
                            </div>
                          </div>

                          {isExpanded && (
                            <div className="bg-white border-x border-gray-200">
                              {sub.questions.length > 0 ? (
                                <table className="w-full text-left border-collapse">
                                  <tbody>
                                    {sub.questions.map((q: any, qIdx: number) => (
                                      <tr
                                        key={q.question_id}
                                        className={`border-b border-gray-100 group f-tahoma hover:bg-[#fff]`}
                                      >
                                        <td className="py-1 px-4 flex items-center gap-3 font-normal text-[16px] group-hover:text-[#006DAA] group-hover:underline decoration-1 underline-offset-2">
                                          <div className="p-1">
                                            <button
                                              className=""
                                              onClick={(e) => {
                                                handleToggleFlag(q.question_id, q.isFlagged, e);
                                              }}
                                            >
                                              <Flag
                                                size={18}
                                                className={`${q.isFlagged ? "fill-[#006DAA] text-[#006DAA]" : "text-[#4678BE] opacity-30"} hover:opacity-100`}
                                              />
                                            </button>
                                          </div>
                                          <span
                                            onClick={() => handleReviewQuestion(q.question_id, allQuestions.findIndex((aq: any) => aq.question_id === q.question_id))}
                                            className="cursor-pointer hover:underline hover:text-blue-600 text-[19px] f-tahoma"
                                          >
                                            Question {qIdx + 1}
                                          </span>
                                        </td>
                                        <td className={`py-1 px-4 font-normal text-[16px] group text-left ${getStatusColor(q.status)}`}>
                                          {formatStatus(q.status)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <div className="px-10 py-4 text-[13px] text-gray-400 italic">
                                  No detailed question results available.
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="w-full py-10 text-center text-gray-500">
                      No review data available. Please complete the exam first.
                    </div>
                  )}

                  {/* Fixed Summary Section */}
                  {evalAs == "exam" && (
                    <div className="flex flex-col">
                      <div
                        onClick={() => setSummaryExpanded(!summaryExpanded)}
                        className="flex items-center justify-between px-4 py-1 bg-[#507abd] text-white hover:bg-[#4068a0] transition-colors cursor-pointer rounded-sm"
                      >
                        <div className="flex items-center gap-3">
                          {summaryExpanded ? <SquareMinus size={18} className="text-white/90" /> : <SquarePlus size={18} strokeWidth={3} className="text-white/90" />}
                          <span className="text-[19px] font-medium f-tahoma">
                            Summary Section
                          </span>
                        </div>
                        <div className="text-[19px] font-medium f-tahoma tracking-wide">
                          ( 0 Questions , 0 Incorrect )
                        </div>
                      </div>

                      {summaryExpanded && (
                        <div className="bg-white border-x border-gray-200">
                          <div className="divide-y divide-gray-100">
                            <div
                              onClick={() => navigate("/ucat_examsummary_practice", { state: { studentExamId: idToUse, fromResultScreen: true, evalAs: "exam" } })}
                              className="flex items-center justify-between px-6 py-1.5 hover:bg-blue-50/30 transition-colors cursor-pointer group"
                            >
                              <div className="flex items-center f-tahoma gap-4">
                                <PenLine size={16} className="text-blue-400 group-hover:text-blue-600" />
                                <span className="text-[16px] text-gray-700 f-tahoma">1</span>
                              </div>
                              <span className="text-[16px] font-normal f-tahoma text-gray-500">
                                Unseen
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </UcatLayout>
      {/* Instructions Modal - Pearson Style */}
      {
        showInstructions && (
          <div className="fixed inset-0 flex items-center justify-center z-[10000] bg-black/40 f-tahoma">
            <div className="bg-[#006DAA] w-[55%] max-w-5xl border border-white shadow-2xl overflow-hidden">
              {/* Title Bar */}
              <div className="text-white px-3 py-3 border-b border-white/30 flex items-center f-tahoma">
                <h2 className="text-[16px] font-normal f-tahoma">Review Instructions</h2>
              </div>

              <div className="p-4 text-white font-[inherit]">
                {/* come back1 */}
                <div className="flex items-start gap-4 mb-4">
                  {/* Info Icon */}
                  <div className="flex-shrink-0 mt-1">
                    <InfoSvg className="w-[48px] h-[48px] text-[#005a9c] fill-white" />
                  </div>

                  <div className="text-[16px] leading-relaxed space-y-6">
                    <p className="text-[16px] f-tahoma">
                      Below is a summary of your answers. You can review your questions in three (3) different ways.
                    </p>

                    <div>
                      <p className="mb-4 text-[16px] f-tahoma">
                        The buttons in the lower right-hand corner correspond to these choices:
                      </p>
                      <div className="space-y-1 ml-1 text-[16px] f-tahoma">
                        <p className="text-[16px] f-tahoma">1. Review all of your questions and answers.</p>
                        <p className="text-[16px] f-tahoma">2. Review questions that are incomplete.</p>
                        <p className="text-[16px] f-tahoma">3. Review questions that are flagged for review. (Click the 'flag' icon to change the flag for review status.)</p>
                      </div>
                    </div>

                    <p className="text-[16px] f-tahoma">
                      You may also click on a question number to link directly to its location in the exam.
                    </p>
                  </div>
                </div>

                {/* Close Button */}
                <div className="flex justify-center mt-12 mb-2">
                  <button
                    onClick={() => setShowInstructions(false)}
                    className="px-2 py-1 border border-white text-white font-700 hover:bg-[#FFFF00] hover:text-[#005a9c] transition-colors text-[18px]"
                  >
                    <span className="f-tahoma underline">O</span>K
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* End Review Confirmation Modal */}
      <EndReviewConfirmationModal
        isOpen={showEndReviewConfirmation}
        onClose={handleEndReviewCancel}
        onConfirm={handleEndReviewConfirm}
        incompleteCount={0}
        isEndExam={true}
      />

      <NoFlaggedModal
        isOpen={showNoFlaggedModal}
        onClose={() => setShowNoFlaggedModal(false)}
      />
    </>
  );
};

export default UcatResultScreen;
